import { render, staticRenderFns } from "./EntregaFormAtualizar.vue?vue&type=template&id=805ddfe2"
import script from "./EntregaFormAtualizar.vue?vue&type=script&lang=js"
export * from "./EntregaFormAtualizar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports